<template>
    <el-dialog
        :visible="visible"
        class="reimbursement-select-dialog ah-detail-dialog"
        top="4vh"
        modal-append-to-body
        append-to-body
        :close-on-click-modal="false"
        :before-close="onBeforeClose"
        @open="onOpen"
    >
        <template slot="title">選擇核銷單</template>
        <div class="wrapper">
            <div class="title-block">
                <div class="title">核銷單搜尋</div>
            </div>
            <div class="search-block">
                <el-input v-model="queryParams.Keyword" suffix-icon="el-icon-search" placeholder="搜尋： 核銷單號、摘要、申請人" style="width: 400px" @keydown.enter.native="onSearch" />
                <el-button style="margin-left: 10px;" @click="onSearch">搜尋</el-button>
            </div>
            <el-table
                ref="Table"
                :data="datas"
                v-loading="isLoading"
                :default-sort="sortSetting"
                class="ah-el-data-table"
                empty-text="沒有資料"
                @selection-change="onSelectionChange"
                @sort-change="onSortChange"
                style="min-height: 500px;"
            >
                <el-table-column key="selection" type="selection" :selectable="isSelectable" width="45"></el-table-column>
                <el-table-column prop="ioo" label="核銷單號" width="120" sortable>
                    <template slot-scope="scope">
                        <span class="invoice-label" @click="$emit('openInvoice', scope.row.sno)">
                            {{ scope.row.ioo }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="狀態" width="90" sortable>
                    <template slot-scope="scope">
                        <InvoiceStatusLabel :statusNum="scope.row.status" />
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="摘要" :min-width="250" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="vdR_NAM" label="客戶" :min-width="150" sortable show-overflow-tooltip> </el-table-column>
                <el-table-column prop="foO_DAT" label="核銷日期" align="left" width="110" sortable>
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="amt" label="核銷單金額" align="right" width="115" sortable>
                    <template slot-scope="scope">
                        <span>
                            <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="tranInvoiceUnInvoiceAmt" label="未開發票金額" align="right" width="125" sortable>
                    <template slot-scope="scope">
                        <span>
                            <Money :v="scope.row.tranInvoiceUnInvoiceAmt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="cny" label="幣別" align="left" width="75" sortable> </el-table-column>
                <el-table-column prop="stF_NAM" label="核銷申請人" align="left" width="120" sortable> </el-table-column>
            </el-table>
            <center>
                <el-pagination
                    layout="prev, pager, next"
                    class="pagination"
                    :page-size.sync="queryParams.PageSize"
                    :current-page.sync="queryParams.PageNum"
                    :total.sync="totalDataCount"
                    :small="isMobile()"
                    @current-change="updateData()"
                >
                </el-pagination>
            </center>
            <center>
                <el-button @click="onBeforeClose">取消</el-button>
                <el-button type="primary" class="primary-action" :disabled="!selectedItems.length" @click="onSubmit">加入已勾選 {{ selectedItems.length }} 筆</el-button>
            </center>
        </div>
    </el-dialog>
</template>

<script>
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';

export default {
    mixins: [],
    props: {
        visible: Boolean,
        sno: {
            type: Number,
            default: null,
        },
        selectedInvoice: {
            type: Array,
            default: () => [],
        },
    },
    components: { InvoiceStatusLabel },
    data() {
        return {
            isLoading: false,
            selectedItems: [],
            queryParams: {
                Keyword: null,
                PageSize: 10,
                PageNum: 1,
            },
            totalDataCount: 0,
            OrderParam: {
                SortColumn: null,
                OrderBy: null,
            },
            datas: [],
        };
    },
    computed: {
        sortSetting() {
            if (this.isSortByDate) {
                return { prop: 'crT_DAT', order: 'descending' };
            }
            return { prop: null, order: null };
        },
    },
    methods: {
        onOpen() {
            this.updateData();
        },

        onSearch() {
            this.updateData();
        },

        updateData(resetPageNum = false) {
            this.isLoading = true;

            if (resetPageNum) this.queryParams.PageNum = 1;

            let params = { ...this.queryParams };
            if (this.OrderParam.SortColumn !== null && this.OrderParam.OrderBy !== null) {
                params = { ...this.OrderParam, ...this.queryParams };
            }

            this.$api({
                url: 'TranInvoice/QueryType4Invoice',
                params: { ...params },
                method: 'GET',
            })
                .then((resp) => {
                    console.log('核銷發票', resp.data);
                    this.datas = resp.data.items;
                    this.totalDataCount = resp.data.totalNum;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onBeforeClose() {
            this.selectedItems = [];
            this.$refs.Table.clearSelection();

            this.queryParams = {
                Keyword: null,
                PageSize: 10,
                PageNum: 1,
            };
            this.totalDataCount = 0;

            this.$emit('close');
        },

        onSortChange(event) {
            if (event.order === 'ascending') {
                this.OrderParam.OrderBy = 1;
            }
            if (event.order === 'descending') {
                this.OrderParam.OrderBy = 2;
            }
            if (event.order === null) {
                this.OrderParam.OrderBy = null;
            }
            this.OrderParam.SortColumn = event.prop;
            this.updateData();
        },

        onSelectionChange(selection) {
            this.selectedItems = selection;
        },

        onSubmit() {
            this.$emit(
                'add',
                this.selectedItems.map((o) => ({ ...o, thisAmt: 0 })),
            );
            this.onBeforeClose();
        },
        isSelectable(row) {
            if (!row.tranInvoiceUnInvoiceAmt) return false;
            return !this.selectedInvoice.includes(row.ioo);
        },
    },
};
</script>

<style lang="scss">
.reimbursement-select-dialog.ah-detail-dialog {

    .el-dialog {
        max-width: 1050px;
        margin-bottom: 4vh !important;
    }

    .title-block {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .title {
            font-size: 15pt;
            font-weight: bold;
            margin-top: 3px;
            flex: 1;
        }
    }
    .invoice-label {
        text-decoration: underline;
        cursor: pointer;
    }

    .wrapper {
        background-color: #fff;
        padding: 30px 10px 40px;
        margin: 12px;
        // text-align: center;
    }
    .ah-el-data-table {
        width: 100%;
    }
    .search-block {
        margin-bottom: 10px;
    }
    .pagination {
        margin: 20px 0;
    }
}
</style>
